<script setup lang="ts">
import {Button, Label, RadioButton} from "@/Components/Library";

const {totalActiveFilters} = defineProps<{totalActiveFilters?: number}>();

const filters = defineModel();
const emit = defineEmits(["apply", "clear"]);
</script>

<template>
    <div>
        <div class="mb-4">
            <h3 class="mb-2 text-lg font-bold">Filter groups by role</h3>
            <div class="flex flex-col gap-3">
                <div class="flex items-center gap-2">
                    <RadioButton v-model="filters.role" inputId="owner" name="role" value="owner" />
                    <Label for="owner">Owner</Label>
                </div>
                <div class="flex items-center gap-2">
                    <RadioButton v-model="filters.role" inputId="admin" name="role" value="admin" />
                    <Label for="admin">Admin</Label>
                </div>
                <div class="flex items-center gap-2">
                    <RadioButton v-model="filters.role" inputId="creator" name="role" value="creator" />
                    <Label for="creator">Creator</Label>
                </div>
                <div class="flex items-center gap-2">
                    <RadioButton v-model="filters.role" inputId="member" name="role" value="member" />
                    <Label for="member">Member</Label>
                </div>
                <div class="flex items-center gap-2">
                    <RadioButton v-model="filters.role" inputId="all" name="role" value="all" />
                    <Label for="all">All</Label>
                </div>
            </div>
        </div>
        <div class="flex gap-2" v-auto-animate>
            <Button class="grow bg-askr-green text-white hover:brightness-110" @click="emit('apply')">Apply</Button>
            <Button
                v-if="totalActiveFilters"
                class="w-10 shrink-0 bg-red-600 text-white hover:brightness-110"
                @click="emit('clear')"
                :icon="{icon: 'mdi:filter-off-outline', width: '24'}"
            />
        </div>
    </div>
</template>

<style scoped></style>
